__turbopack_context__.v({
  "className": "me7rJG_className",
});
